import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { ConfiguredGraph } from 'src/swagger-gen/web-secured/models/configured-graph';
import { ConfiguredGraphOrder } from 'src/swagger-gen/web-secured/models/configured-graph-order';
import { AlertParameters, AlertType } from '../../models/models-index';
import { AlertService } from 'src/app/services';

@Component({
    selector: 'app-modal-organize-configured-graphs',
    templateUrl: './modal-organize-configured-graphs.component.html',
    styleUrls: ['./modal-organize-configured-graphs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalOrganizeConfiguredGraphsComponent implements OnInit {

  uidStation: string; 
  graphs: ConfiguredGraph[] = [];

  constructor( @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ModalOrganizeConfiguredGraphsComponent>, private stationRepo: StationsRepo,private translate: TranslateService, private alertService: AlertService) {
    this.graphs = JSON.parse(JSON.stringify(this.data.graphs));
    this.uidStation = this.data.uidStation;
  }

  ngOnInit(): void {
  }

  onDrop(event: CdkDragDrop<string[]>) {
    const movedItem = this.graphs[event.previousIndex];
    this.graphs.splice(event.previousIndex, 1);
    this.graphs.splice(event.currentIndex, 0, movedItem);
  }

  onSubmit() {
    const orderedObject: ConfiguredGraphOrder = this.graphs.reduce((acc, item, index) => {
      acc.order[index] = item.uid;
      return acc;
    }, { order: {} });
    
    this.graphs.forEach((elm) => {
      this.stationRepo.updateGraph(this.uidStation,elm.uid,elm).toPromise()
      .catch((error) => {
        this.showAlert(error);
        console.error(error);
      })
    })

    this.stationRepo.orderGraph(this.uidStation, orderedObject).toPromise()
    .then(() => {
      this.dialogRef.close(true);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  onCheckboxChange(index: any) {
    this.graphs[index].inDashboard = this.graphs[index].inDashboard ? !this.graphs[index].inDashboard : true
  }
  showAlert(error: any) {
    const title = this.translate.instant('error.title');
    const alertParams = new AlertParameters(
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      title
    );
    this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  }


}
